import { useState, useEffect } from "react";
import { Cookie } from "lucide-react";
import { openLegal } from "@/components/site/Legal";

const KEY = "praxis-cookie-consent";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setShow(true);
    }, 1200);
    return () => clearTimeout(t);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed z-[70] bottom-4 left-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-2xl rounded-2xl bg-cream shadow-[0_20px_50px_-15px_rgba(44,38,33,0.5)] ring-1 ring-gold/25 p-5 sm:p-6"
    >
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3">
          <span className="shrink-0 h-10 w-10 rounded-full bg-gold/15 flex items-center justify-center">
            <Cookie size={20} strokeWidth={1.5} className="text-gold-deep" />
          </span>
          <p className="text-sm text-charcoal-soft leading-relaxed">
            Diese Website verwendet nur technisch notwendige Cookies. Externe Inhalte (z. B. Google Maps) werden erst
            nach Ihrer Zustimmung geladen. Mehr in der{" "}
            <button
              onClick={() => openLegal("datenschutz")}
              className="text-gold-deep underline underline-offset-2 hover:text-charcoal"
              data-testid="cookie-datenschutz-link"
            >
              Datenschutzerklärung
            </button>
            .
          </p>
        </div>
        <div className="flex gap-3 sm:flex-col sm:shrink-0">
          <button
            data-testid="cookie-necessary"
            onClick={() => decide("necessary")}
            className="flex-1 rounded-full border border-gold/50 text-charcoal px-5 py-2.5 text-sm hover:bg-gold/10 transition-colors duration-300 whitespace-nowrap"
          >
            Nur notwendige
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => decide("all")}
            className="flex-1 rounded-full bg-charcoal text-gold-soft px-5 py-2.5 text-sm hover:bg-charcoal-soft transition-colors duration-300 whitespace-nowrap"
          >
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
};
